const sharedZones = [
    {
        "id": 32,
        "personSrc": "/img/DameAgee.png",
        "personName": "Dame âgée",
        "color": "rose_fonce",
        "coords": {
            "x": 1768,
            "y": 748
        },
        "buttonText": "Fermer",
        "required": false,
        "width": 56,
        "height": 66,
        "content": [
            {
                "text": "Un gentil garçon m’a cédé sa place ! Je peux profiter du trajet pour me reposer avant de continuer mes courses.",
                "audioSrc": "/audio/DameAgeeE3-1.mp3"
            }
        ]
    },
    {
        "id": 33,
        "personSrc": "/img/Homme.png",
        "personName": "Homme",
        "color": "sapin",
        "coords": {
            "x": 770,
            "y": 932
        },
        "buttonText": "Fermer",
        "required": false,
        "width": 87,
        "height": 252,
        "content": [
            {
                "text": "Surtout, ce n’est pas la peine de pousser les gens devant toi lorsque le bus arrive : le conducteur te laissera toujours le temps de monter.",
                "audioSrc": "/audio/HommeE3-1.mp3"
            }
        ]
    },
    {
        "id": 34,
        "personSrc": "/img/Lyceen.png",
        "personName": "Lycéen",
        "coords": {
            "x": 1684,
            "y": 710
        },
        "buttonText": "Fermer",
        "required": false,
        "width": 62,
        "height": 75,
        "content": [
            {
                "text": "Combien de voitures un bus peut-il remplacer en termes de capacité de transport de passagers ? Ça, c’est une vraie question ! T’y as déjà réfléchi ?",
                "audioSrc": "/audio/LyceenE3-1.mp3"
            }
        ]
    },
    {
        "id": 35,
        "personSrc": "/img/JeuneFemme.png",
        "personName": "Jeune femme",
        "coords": {
            "x": 228,
            "y": 1041
        },
        "buttonText": "Fermer",
        "required": false,
        "width": 95,
        "height": 311,
        "content": [
            {
                "text": "Il arrive que le bus arrive entre 1  à 5 minutes avant ou après l’horaire indiqué. Cela n’est pas considéré comme du retard, il faut donc toujours arriver à l’arrêt avec un peu d’avance.",
                "audioSrc": "/audio/JeuneFemmeE3-1.mp3"
            }
        ]
    },
    {
        "id": 36,
        "personSrc": "/img/TeteEnLAir.png",
        "personName": "Homme tête en l'air",
        "color": "rose_fonce",
        "coords": {
            "x": 1461,
            "y": 918
        },
        "required": false,
        "buttonText": "Fermer",
        "width": 77,
        "height": 59,
        "content": [
            {
                "text": "Je descends au prochain arrêt, est-ce que j’ai bien appuyé sur le bouton “stop” ?",
                "audioSrc": "/audio/TeteEnLAirE3-1.mp3"
            }
        ]
    },
    {
        "id": 37,
        "info": "La zone cliquable est : L’arrêt de bus",
        "personSrc": "/img/Max.png",
        "personName": "Max",
        "coords": {
            "x": 191,
            "y": 515
        },
        "required": false,
        "buttonText": "Fermer",
        "width": 187,
        "height": 154,
        "content": [
            {
                "text": "En fonction de ton arrêt, tu verras soit un poteau, soit un abribus, soit les deux ! Dans tous les cas, tu pourras retrouver toutes les informations dont tu as besoin pour voyager dans les cadres d’affichage.",
                "audioSrc": "/audio/MaxE3-1.mp3"
            }
        ]
    },
    {
        "id": 38,
        "info": "La zone cliquable est : Le numéro de la ligne sur le bus.",
        "personSrc": "/img/Max.png",
        "personName": "Max",
        "coords": {
            "x": 963,
            "y": 724
        },
        "buttonText": "Fermer",
        "required": false,
        "width": 430,
        "height": 80,
        "rotate": 26,
        "content": [
            {
                "text": "Tous les bus de ville affichent le numéro de la ligne à l’avant du bus, ainsi que la direction qui correspond aussi à son terminus. Tu verras, tu les retiendras vite.",
                "audioSrc": "/audio/MaxE3-2.mp3"
            }
        ]
    },
    {
        "id": 39,
        "info": "La zone cliquable est : Un ado avec une bombe de peinture à proximité",
        "personSrc": "/img/Ado.png",
        "personName": "Ado",
        "color": "sapin",
        "coords": {
            "x": 1253,
            "y": 392
        },
        "required": false,
        "buttonText": "Fermer",
        "width": 62,
        "height": 129,
        "content": [
            {
                "text": "Quoi ? Tu pensais que j’allais taguer l’abribus ? Non ! T’es ouf ! C’est interdit, et puis moi ça ne m'intéresse pas de dégrader le matériel qui ne m’appartient pas ! Au skatepark, j’ai un super spot où je peux taguer.",
                "audioSrc": "/audio/AdoE3-1.mp3"
            }
        ]
    }
];

const interactiveDataJson  = [
    {
        "step": 1,
        "hints": [
            {
                "order": 1,
                "text": "Tu as regardé en haut à droite, à côté du poteau d’arrêt ?"
            }
        ],
        "buttonText": "Cherche Max et son skate."
    },
    {
        "step": 2,
        "hints": [
            {
                "order": 1,
                "text": "Tu as regardé en haut à droite, à côté du poteau d’arrêt ?"
            }
        ],
        "zones": [
            {
                "id": 21,
                "personSrc": "/img/Max.png",
                "personName": "Max",
                "required": true,
                "coords": {
                    "x": 1160,
                    "y": 340
                },
                "width": 66,
                "height": 201,
                "order": 1,
                "buttonText": "Monte dans le bus et va voir le conducteur.",
                "color": "sapin",
                "content": [
                    {
                        "text": "Salut ! Tu cherches quelque chose ? Prendre le bus ? Facile !<br> Sur chaque poteau d’arrêt et dans les abribus, tu peux voir les heures de passage et les itinéraires des lignes de bus. La tienne, c’est la ligne B, elle va jusqu’au collège.",
                        "audioSrc": "/audio/MaxE1-1.mp3"
                    },
                    {
                        "text": "Quand tu vois un bus arriver, vérifie son numéro et sa direction au-dessus de son pare-brise. Si c’est bien le bus que tu dois prendre, fais-lui signe de s'arrêter et attends bien que les passagers descendent avant de monter.",
                        "audioSrc": "/audio/MaxE1-2.mp3"
                    },
                    {
                        "text": "D’ailleurs, ton bus arrive déjà. Pas besoin de courir après, ça peut être dangereux. Le conducteur ne peut pas voir tout ce qui se passe autour de lui, on appelle cette zone invisible l’angle mort. Avec ton abonnement sur la carte, tu n’as qu’à biper. Si tu n’as pas d’abonnement, tu peux acheter un titre de transport directement auprès du conducteur. Et n’oublie pas de lui dire bonjour.",
                        "audioSrc": "/audio/MaxE1-3.mp3"
                    }
                ]
            }
        ]
    },
    {
        "step": 3,
        "hints": [
            {
                "order": 1,
                "text": "Pour monter dans le bus, tu peux voir avec le conducteur si tu n’y arrives pas !"
            }
        ],
        "zones": [
            {
                "id": 31,
                "personSrc": "/img/Chauffeur.png",
                "personName": "Le conducteur",
                "coords": {
                    "x": 1200,
                    "y": 973
                },
                "required": true,
                "width": 85,
                "height": 147,
                "order": 1,
                "buttonText": "Cherche une place libre.",
                "color": "sapin",
                "content": [
                    {
                        "text": "Bonjour ! Tu as besoin d’un ticket à l’unité ? Pas de problème ! Sache qu’il y a des abonnements qui te permettent de voyager sans te soucier de tout ça. C'est comme un pass VIP pour les bus. Généralement, tu peux les avoir sur les bornes, dans les guichets ou même en ligne. Pour en savoir plus, je t’invite à te rendre sur le site des transports en commun de ta ville !",
                        "audioSrc": "/audio/ChauffeurE2-1.mp3"
                    },
                    {
                        "text": "Pour valider ton ticket, c’est très simple : bipe-le sur cette machine. Ensuite, va t'asseoir s’il y a de la place ou tiens-toi aux barres de maintien pour ne pas tomber. Si tu montes dans un car, n’oublie pas d’attacher ta ceinture ! Bon voyage !",
                        "audioSrc": "/audio/ChauffeurE2-2.mp3"
                    }
                ]
            },
            ...sharedZones
        ]
    },
    {
        "step": 4,
        "hints": [
            {
                "order": 1,
                "text": "Il n’y a qu’une seule place libre vers le fond du bus, tu ne peux pas te tromper !"
            }
        ],
        "zones": [
            {
                "id": 41,
                "info": "La zone cliquable est : la place libre vers le fond du bus.",
                "personSrc": "/img/Max.png",
                "personName": "Max",
                "required": true,
                "coords": {
                    "x": 2405,
                    "y": 405
                },
                "rotate": -48,
                "width": 130,
                "height": 90,
                "order": 1,
                "color": "sapin",
                "buttonText": "Cherche l’agent du réseau.",
                "content": [
                    {
                        "text": "Tu ne crois pas que tu devrais laisser ta place à la dame âgée qui vient de monter ?",
                        "audioSrc": "/audio/MaxE4-1.mp3",
                        "buttonText": "Oui, je cède ma place.",
                        "autoNext":false
                    },
                    {
                        "personSrc": "/img/DameAgee.png",
                        "personName": "La dame âgée",
                        "color": "rose_fonce",
                        "text": "Merci beaucoup.<br> Tu as l’air de savoir que les personnes âgées, les femmes enceintes et les personnes en situation de handicap ont la priorité pour s'asseoir. D’ailleurs, certaines places du bus nous sont parfois réservées. <br> Si tu as des questions sur la conduite à avoir dans les transports en commun, demande à l'agent du réseau, il est sympa... et il connaît tout par cœur !",
                        "audioSrc": "/audio/DameAgeeE4-1.mp3"
                    }
                ]
            },
            ...sharedZones
        ]
    },
    {
        "step": 5,
        "hints": [
            {
                "order": 1,
                "text": "Il est facile à trouver au milieu du bus avec sa carte autour de son cou !"
            }
        ],
        "zones": [
            {
                "id": 51,
                "personSrc": "/img/Mediateur.png",
                "personName": "L’agent de médiation",
                "required": true,
                "coords": {
                    "x": 1806,
                    "y": 656
                },
                "width": 94,
                "height": 143,
                "order": 1,
                "buttonText": "Clique sur les 6 comportements à éviter dans le bus.",
                "color": "or",
                "content": [
                    {
                        "text": "Salut ! Hé, c’est ta première fois en solo ? Respect ! <br> Alors comme ça, tu veux tout savoir sur la bonne conduite dans le bus ? Commençons par un petit défi ! Est-ce que tu peux m'aider à repérer 6 incivilités dans ce bus ? <br> Si tu n’arrives pas à toutes les trouver, tu peux cliquer sur le bouton “indices”.",
                        "audioSrc": "/audio/MediateurE5-1.mp3"
                    }
                ]
            },
            ...sharedZones
        ]
    },
    {
        "step": 6,
        "personSrc": "/img/Mediateur.png",
        "personName": "L’agent de médiation",
        "buttonText": "Appuie sur le bouton pour signaler ton souhait de descendre au prochain arrêt.",
        "content": [
            {
                "text": "Bravo, tu as surmonté ce défi les yeux fermés ! Mais ne te repose pas sur tes lauriers : il y a encore bien des incivilités à éviter. Si tu interroges les autres passagers, peut-être qu’ils te donneront d’autres exemples.",
                "audioSrc": "/audio/MediateurE6-8.mp3"
            },
            {
                "personSrc": "/img/Chauffeur.png",
                "personName": "L’annonce du bus",
                "text": "PROCHAIN ARRÊT : le collège Pauline Kergomard.",
                "audioSrc": "/audio/BusE6-1.mp3"
            },
            {
                "text": "Ah, c’est ton arrêt ! Tu dois donc appuyer sur le bouton pour demander l’arrêt au conducteur. Il y en a plusieurs : sur les barres métalliques verticales proches des portes et à d’autres endroits près des sièges. Évite de le faire au dernier moment pour ne pas surprendre le conducteur.",
                "audioSrc": "/audio/MediateurE6-9.mp3"
            },
            {
                "text": "Un dernier mot : si tu as pris un ticket papier, ne le jette pas n’importe où s’il te plait ! On peut les recycler s’ils sont jetés à la poubelle.",
                "audioSrc": "/audio/MediateurE6-10.mp3"
            }
        ],
        "hints": [
            {
                "order": 1,
                "text": "Dans un bus, nous n’avons pas le droit de manger !",
                "idZone": 61
            },
            {
                "order": 2,
                "text": "On ne doit pas écouter de la musique sans écouteur non plus…",
                "idZone": 62
            },
            {
                "order": 3,
                "text": "Tu aimerais t’asseoir sur un siège sur lequel quelqu’un a mis ses chaussures ?",
                "idZone": 63
            },
            {
                "order": 4,
                "text": "On doit également ne pas chahuter pour ne pas se blesser et ne pas déranger les autres voyageurs.",
                "idZone": 65
            },
            {
                "order": 5,
                "text": "On évite de garder son sac à dos sur les épaules, ça prend trop de place…",
                "idZone": 64
            },
            {
                "order": 6,
                "text": "Les marteaux brise-vitre, on ne peut s’en servir qu’en cas d’urgence vitale !",
                "idZone": 66
            }
        ],
        "zones": [
            {
                "id": 61,
                "info": "La zone cliquable est : Une jeune fille qui mange un sandwich au fond du bus.",
                "personSrc": "/img/Mediateur.png",
                "personName": "L’agent de médiation",
                "required": true,
                "coords": {
                    "x": 2525,
                    "y": 378
                },
                "width": 83,
                "height": 127,
                "color": "rose_fonce",
                "buttonText": "Fermer",
                "content": [
                    {
                        "text": "Bingo ! Il est important de ne pas manger dans le bus pour le garder propre tout au long de la journée. Plus globalement, il est interdit de souiller ou dégrader le bus.",
                        "audioSrc": "/audio/MediateurE6-1.mp3"
                    }
                ]
            },
            {
                "id": 62,
                "info": "La zone cliquable est : Un garçon qui écoute de la musique avec une enceinte.",
                "personSrc": "/img/Mediateur.png",
                "personName": "L’agent de médiation",
                "required": true,
                "coords": {
                    "x": 1648,
                    "y": 800
                },
                "width": 84,
                "height": 146,
                "color": "sapin",
                "buttonText": "Fermer",
                "content": [
                    {
                        "text": "Exactement ! Respecte les autres passagers en évitant de faire du bruit, ils ne sont pas intéressés par ce que tu écoutes. Et ça vaut aussi pour les coups de fil : tout le bus n’a pas besoin de savoir que tu manges des lasagnes ce soir à la maison.",
                        "audioSrc": "/audio/MediateurE6-2.mp3"
                    }
                ]
            },
            {
                "id": 63,
                "info": "La zone cliquable est : Un garçon met ses pieds sur le siège de devant.",
                "personSrc": "/img/Mediateur.png",
                "personName": "L’agent de médiation",
                "required": true,
                "coords": {
                    "x": 2023,
                    "y": 600
                },
                "width": 71,
                "height": 177,
                "color": "sapin",
                "buttonText": "Fermer",
                "content": [
                    {
                        "text": "Tu as raison ! Non seulement ça gêne les passagers de devant, mais en plus ça salit les sièges et ça finit par les abîmer. En plus, tu peux recevoir une amende pour ce genre de comportement. Elle peut être de 90€ ou plus, tu imagines tout ce que tu pourrais faire avec cet argent ?",
                        "audioSrc": "/audio/MediateurE6-3.mp3"
                    }
                ]
            },
            {
                "id": 64,
                "info": "La zone cliquable est : Une jeune femme est debout avec son sac à dos",
                "personSrc": "/img/Mediateur.png",
                "personName": "L’agent de médiation",
                "required": true,
                "coords": {
                    "x": 1946,
                    "y": 545
                },
                "width": 89,
                "height": 127,
                "color": "rose_fonce",
                "buttonText": "Fermer",
                "content": [
                    {
                        "text": "Bravo ! Cette jeune femme gêne les autres passagers du bus avec le sac qu’elle a sur le dos. Elle occupera moins de place s’elle l’enlève. <br> D’ailleurs, puisqu’on parle des sacs, on ne les pose pas non plus sur le siège d’à côté quand on est assis, sauf s'il y a peu de gens dans le véhicule. Il faut libérer les places pour ceux qui veulent s’asseoir !",
                        "audioSrc": "/audio/MediateurE6-4.mp3"
                    }
                ]
            },
            {
                "id": 65,
                "info": "La zone cliquable est : Deux ados chahutent à l’arrière.",
                "personSrc": "/img/Mediateur.png",
                "personName": "L’agent de médiation",
                "required": true,
                "coords": {
                    "x": 2566,
                    "y": 275
                },
                "width": 131,
                "height": 108,
                "color": "rose_fonce",
                "buttonText": "Fermer",
                "content": [
                    {
                        "text": "Eh oui ! Attention, les enfants ! Vos bousculades pourraient perturber le conducteur, provoquer des incidents et même te mettre en danger car tu pourrais tomber toi aussi. <br> Dans le bus, on reste calme et respectueux. D’ailleurs, il est important que tu saches que si tu es victime ou témoin de harcèlement dans les transports en commun, tu peux venir nous voir, le conducteur ou moi, ou en parler à un camarade. Nous trouverons une solution ensemble.",
                        "audioSrc": "/audio/MediateurE6-5.mp3"
                    }
                ]
            },
            {
                "id": 66,
                "info": "La zone cliquable est : Un garçon touche au marteau brise-vitre, semble-t-il pour rigoler.",
                "personSrc": "/img/Mediateur.png",
                "personName": "L’agent de médiation",
                "required": true,
                "coords": {
                    "x": 2620,
                    "y": 156
                },
                "width": 112,
                "height": 133,
                "color": "or",
                "buttonText": "Fermer",
                "content": [
                    {
                        "text": "Tu as l'œil ! Il est strictement interdit de toucher au marteau brise-vitre sans raison valable. On ne l’utilise qu’en situation d’urgence, par exemple en cas d’incendie, pour permettre aux passagers de sortir immédiatement du bus.<br> On ne doit pas non plus s’amuser avec les issues de secours et le système de décompression des portes. Ce règlement est très important : l’usager fautif peut recevoir une amende s’il ne le respecte pas.",
                        "audioSrc": "/audio/MediateurE6-6.mp3"
                    }
                ]
            },
            {
                "id": 67,
                "personSrc": "/img/Mediateur.png",
                "personName": "L’agent de médiation",
                "required": false,
                "coords": {
                    "x": 1806,
                    "y": 656
                },
                "width": 94,
                "height": 143,
                "order": 1,
                "buttonText": "Clique sur les 6 comportements à éviter dans le bus.",
                "color": "or",
                "content": [
                    {
                        "text": "Pas facile, hein ? N’hésite pas à t’aider des indices. Et ne perd pas ton sang froid, ce n’est pas agréable d’avoir un râleur dans le bus !",
                        "audioSrc": "/audio/MediateurE6-7.mp3"
                    }
                ]
            },
            ...sharedZones
        ]
    },
    {
        "step": 7,
        "hints": [
            {
                "order": 1,
                "text": " Regarde sur les barres latérales qui te permettent de ne pas tomber, tu trouveras le bouton d’arrêt, il est orange ! "
            }
        ],
        "personName": "Le conducteur",
        "personSrc": "/img/Chauffeur.png",
        "content": [
            {
                "text": "Bien joué ! Il faut toujours me prévenir quand tu veux descendre au prochain arrêt ! Descends prudemment et n'oublie pas de traverser la route au passage piéton en toute sécurité, en regardant les feux de circulation et autour de toi, une fois que je suis reparti. Tu ne dois jamais traverser devant un bus parce qu’on risque de ne pas te voir. À bientôt, j’espère !",
                "audioSrc": "/audio/ChauffeurE7-1.mp3"
            }
        ],
        "buttonText": "Clique sur l’endroit où tu dois traverser pour te rendre au collège.",
        "changeBackground": true,
        "zones": [
            {
                "id": 71,
                "info": "La zone cliquable est : Femme d’environ 30 ans rousse qui se tient à la barre dans le bus.",
                "personSrc": "/img/FemmeSoucieuse.png",
                "personName": "Femme soucieuse",
                "required": false,
                "coords": {
                    "x": 1568,
                    "y": 886
                },
                "width": 99,
                "height": 164,
                "order": 1,
                "buttonText": "Fermer",
                "color": "sapin",
                "content": [
                    {
                        "text": "Je m’accroche bien à la barre cette fois-ci. La dernière fois, le conducteur a dû freiner brusquement à cause d’un obstacle sur la route et je suis tombée.",
                        "audioSrc": "/audio/FemmeSoucieuseE7-1.mp3"
                    }
                ]
            },
            {
                "id": 72,
                "info": "La zone cliquable est : Le bouton d’arrêt.",
                "personSrc": "/img/Max.png",
                "personName": "Max",
                "required": true,
                "coords": {
                    "x": 1627,
                    "y": 795
                },
                "width": 25,
                "height": 51,
                "order": 1,
                "buttonText": "Fermer",
                "color": "or",
                "content": [
                    {
                        "text": "Bravo ! Tu as appuyé sur le bouton d’arrêt pour signaler au conducteur que tu souhaites descendre au prochain arrêt. Il est important de le faire suffisamment à l’avance pour que le conducteur puisse s’arrêter en toute sécurité.",
                        "audioSrc": "/audio/MaxE7-1.mp3"
                    }
                ]
            },
            {
                "id": 73,
                "info": "La zone cliquable est : Homme roux assis derrière le conducteur du bus.",
                "personSrc": "/img/HommeAssis.png",
                "personName": "Homme assis",
                "required": false,
                "coords": {
                    "x": 1379,
                    "y": 976
                },
                "width": 153,
                "height": 166,
                "order": 1,
                "buttonText": "Fermer",
                "color": "sapin",
                "content": [
                    {
                        "text": "Vous avez regardé le match de football hier soir ? Quel match ! On a quand même une sacrée équipe, qu’est-ce que vous en pensez, conducteur ? Ah ! Excusez-moi. Je vois que je vous dérange.",
                        "audioSrc": "/audio/HommeAssisE7-1.mp3"
                    },
                    {
                        "personSrc": "/img/Chauffeur.png",
                        "personName": "Le conducteur",
                        "text": "Il faut éviter de me parler ou de me distraire : je dois rester concentré sur la route !",
                        "audioSrc": "/audio/ChauffeurE7-2.mp3"
                    }
                ]
            },
            {
                "id": 74,
                "info": "La zone cliquable est : Homme d’environ 40 ans qui se lamente en pointant l’arrière du bus",
                "personSrc": "/img/HommeLamentant.png",
                "personName": "Homme se lamentant",
                "required": false,
                "coords": {
                    "x": 2236,
                    "y": 481
                },
                "width": 92,
                "height": 139,
                "order": 1,
                "buttonText": "Fermer",
                "color": "sapin",
                "content": [
                    {
                        "text": "Regardez-moi ces inscriptions sur les sièges… Personne n’a envie de s’asseoir là-dessus ! Plus on devra dépenser de l’argent pour réparer, plus le ticket de bus coûtera cher…",
                        "audioSrc": "/audio/HommeLamentantE7-1.mp3"
                    }
                ]
            },
            {
                "id": 75,
                "info": "La zone cliquable est : Femme âgée d’environ 70 ans qui écoute de la musique avec un casque.",
                "personSrc": "/img/FemmeAgeeChantonne.png",
                "personName": "Femme âgée qui chantonne",
                "required": false,
                "coords": {
                    "x": 2682,
                    "y": 247
                },
                "width": 102,
                "height": 145,
                "buttonText": "Fermer",
                "color": "sapin",
                "content": [
                    {
                        "text": "C’est oui ou bien c’est non ? Hier, tu me voulaiiis… Oh pardon ! Je ne m’entends pas toujours chanter !",
                        "audioSrc": "/audio/FemmeAgeeChantonneE7-1.mp3"
                    }
                ]
            },
            {
                "id": 76,
                "info": "La zone cliquable est : Femme d’environ 40 ans lisant un livre.",
                "personSrc": "/img/Lectrice.png",
                "personName": "Lectrice",
                "required": false,
                "coords": {
                    "x": 2081,
                    "y": 658
                },
                "width": 108,
                "height": 130,
                "buttonText": "Fermer",
                "color": "rose_fonce",
                "content": [
                    {
                        "text": "Je n’ai rien contre les téléphones. Mais franchement, un bon livre, c’est quand même génial pour se plonger dans une aventure ! En revanche, je reste toujours vigilante pour ne pas rater mon arrêt !",
                        "audioSrc": "/audio/LectriceE7-1.mp3"
                    }
                ]
            },
            {
                "id": 77,
                "info": "La zone cliquable est : Homme d’environ 30 ans, un brin rêveur, regardant à travers la fenêtre.",
                "personSrc": "/img/HommeReveur.png",
                "personName": "Homme rêveur",
                "required": false,
                "coords": {
                    "x": 2431,
                    "y": 456
                },
                "width": 79,
                "height": 128,
                "buttonText": "Fermer",
                "color": "sapin",
                "content": [
                    {
                        "text": "Je préfère toujours la siège à côté de la vitre pour pouvoir observer la nature et le paysage…",
                        "audioSrc": "/audio/HommeReveurE7-1.mp3"
                    }
                ]
            },
            ...sharedZones
        ]
    },
    {
        "step": 8,
        "hints": [
            {
                "order": 1,
                "text": "Le passage piéton, c’est idéal pour traverser. Ce sont les grandes bandes blanches au sol juste derrière le bus."
            }
        ],
        "zones": [
            {
                "id": 81,
                "info": "La zone cliquable est : Homme d’environ 40 ans qui parle fort.",
                "personSrc": "/img/HommeParleFort.png",
                "personName": "Homme qui parle fort",
                "required": false,
                "coords": {
                    "x": 1700,
                    "y": 1200
                },
                "width": 113,
                "height": 127,
                "buttonText": "Fermer",
                "color": "sapin",
                "content": [
                    {
                        "text": "Ah, ce quartier, je le connais bien, j’y ai grandi !",
                        "audioSrc": "/audio/HommeParleFortE7-1.mp3"
                    }
                ]
            },
            {
                "id": 82,
                "info": "La zone cliquable est : Sa voisine d’environ 60 ans",
                "personSrc": "/img/Voisine.png",
                "personName": "Voisine",
                "required": false,
                "coords": {
                    "x": 1626,
                    "y": 1222
                },
                "width": 97,
                "height": 135,
                "buttonText": "Fermer",
                "color": "rose_fonce",
                "content": [
                    {
                        "text": "Cet homme parle très fort, il gêne tout le monde dans le bus. Monsieur, pourriez-vous baisser d’un ton, s’il vous plaît ?",
                        "audioSrc": "/audio/VoisineE7-1.mp3"
                    }
                ]
            },
            {
                "id": 83,
                "info": "La zone cliquable est : le Chauffeur",
                "personSrc": "/img/Chauffeur.png",
                "personName": "Le conducteur",
                "required": false,
                "coords": {
                    "x": 2300,
                    "y": 1313
                },
                "width": 87,
                "height": 136,
                "buttonText": "Fermer",
                "color": "sapin",
                "content": [
                    {
                        "text": "Il faut éviter de me parler ou de me distraire : je dois rester concentré sur la route !",
                        "audioSrc": "/audio/VoisineE7-1.mp3"
                    }
                ]
            },
            {
                "id": 84,
                "info": "La zone cliquable est : passage pieton",
                "personSrc": "/img/AgentTraversee.png",
                "personName": "Agent de traversée",
                "required": true,
                "coords": {
                    "x": 270,
                    "y": 770
                },
                "rotate": -32,
                "width": 1200,
                "height": 350,
                "buttonText": "Continue de cliquer sur les différents personnages, puis clique sur la porte du collège dès que tu te sens prêt à récupérer ton badge de niveau 2 du permis jeune mobilité.",
                "color": "or",
                "content": [
                    {
                        "text": "Bravo, il n’y a pas de meilleur endroit pour traverser que ces fameuses bandes blanches qu’on appelle “passage piéton”. Et s’il y a un feu de signalisation bicolore, attends bien qu’il passe au vert !",
                        "audioSrc": "/audio/AgentTraverseeE8-1.mp3"
                    },
                    {
                        "text": "Moi je suis Sam : je viens souvent pour aider à traverser la route. Je fais en sorte d’arrêter les voitures un peu trop pressées et je sensibilise à la sécurité. Et tout ça, avec le sourire !",
                        "audioSrc": "/audio/AgentTraverseeE8-2.mp3"
                    },
                    {
                        "text": "Le collège ferme bientôt ses portes. Il te reste encore un peu de temps pour parler avec les différents personnages et en apprendre un peu plus sur les modes de déplacement écologiques comme le bus, la marche ou le vélo.",
                        "audioSrc": "/audio/AgentTraverseeE8-3.mp3"
                    },
                    {
                        "text": "Si tu te sens prêt, tu peux entrer dès maintenant dans le collège pour récupérer ton badge de niveau 2 du Permis Jeune Mobilité !",
                        "audioSrc": "/audio/AgentTraverseeE8-4.mp3"
                    }
                ]
            }
        ]
    },
    {
        "step": 9,
        "hints": [
            {
                "order": 1,
                "text": " Cherche les personnes ou les objets qui ont des choses à te dire ! Si tu veux passer au quiz, clique sur la porte d’entrée du collège !"
            }
        ],
        "zones": [
            {
                "id": 91,
                "info": "La zone cliquable est : Une professeure du collège",
                "personSrc": "/img/Maitresse.png",
                "personName": "Professeure du collège",
                "required": true,
                "coords": {
                    "x": 2200,
                    "y": 95
                },
                "width": 90,
                "height": 287,
                "buttonText": "Oui, on y va !",
                "goquiz": true,
                "buttonTextCancel": "Non, je souhaite encore me balader aux abords du collège.",
                "color": "rose_fonce",
                "content": [
                    {
                        "text": "Bravo, tu as pris le bus pour venir au collège! Tu vas voir, ça fait du bien d’être autonome. On a l’impression d’être vraiment grand tout à coup. Et c’est un mode de transport bien plus écologique ! <br> Te sens-tu prêt à vérifier que tu as bien retenu les enseignements reçus tout au long de ton trajet en bus ? ",
                        "audioSrc": "/audio/MaitresseE9-1.mp3"
                    }
                ]
            },
            {
                "id": 92,
                "info": "La zone cliquable est : Enfant 1",
                "personSrc": "/img/EnfantALaise.png",
                "personName": "Enfant à l'aise",
                "required": false,
                "coords": {
                    "x": 1923,
                    "y": 181
                },
                "width": 80,
                "height": 190,
                "buttonText": "Fermer",
                "color": "sapin",
                "content": [
                    {
                        "text": "Franchement, c’est cool le bus ! Ça passe vite, on discute avec les copains et on croise souvent les mêmes personnes.",
                        "audioSrc": "/audio/EnfantALaiseE9-1.mp3"
                    }
                ]
            },
            {
                "id": 93,
                "info": "La zone cliquable est : Enfant 2",
                "personSrc": "/img/Enfant.png",
                "personName": "Enfant",
                "required": false,
                "coords": {
                    "x": 2295,
                    "y": 377
                },
                "width": 75,
                "height": 176,
                "buttonText": "Fermer",
                "color": "sapin",
                "content": [
                    {
                        "text": "Je prends le bus seul depuis que j’ai 10 ans. Tu vas voir, c’est très simple.",
                        "audioSrc": "/audio/EnfantE9-1.mp3"
                    }
                ]
            }, {
                "id": 94,
                "info": "La zone cliquable est : Un parent à vélo (casqué).",
                "personSrc": "/img/ParentVelo.png",
                "personName": "Parent à vélo",
                "required": false,
                "coords": {
                    "x": 1712,
                    "y": 60
                },
                "width": 132,
                "height": 262,
                "buttonText": "Fermer",
                "color": "rose_fonce",
                "content": [
                    {
                        "text": "L'écomobilité, c'est quand les gens utilisent des moyens de transport qui ne polluent pas beaucoup, comme le vélo, la marche à pied, le covoiturage ou les voitures qui fonctionnent à l'électricité. C'est une façon de se déplacer en respectant la nature.",
                        "audioSrc": "/audio/ParentVeloE9-1.mp3"
                    }
                ]
            },

            {
                "id": 95,
                "info": "La zone cliquable est : Son enfant à vélo également (avec un casque).",
                "personSrc": "/img/EnfantVelo.png",
                "personName": "Enfant à vélo",
                "required": false,
                "coords": {
                    "x": 1378,
                    "y": 71
                },
                "width": 185,
                "height": 226,
                "buttonText": "Fermer",
                "color": "sapin",
                "content": [
                    {
                        "text": "J’ai trop de chance de pouvoir venir à vélo.",
                        "audioSrc": "/audio/EnfantVeloE9-1.mp3"
                    }
                ]
            },
            {
                "id": 96,
                "info": "La zone cliquable est : Un enfant qui sort d’une voiture.",
                "personSrc": "/img/EnfantRetard.png",
                "personName": "Enfant en retard",
                "required": false,
                "coords": {
                    "x": 18,
                    "y": 482
                },
                "width": 106,
                "height": 226,
                "buttonText": "Fermer",
                "color": "sapin",
                "content": [
                    {
                        "text": "D’habitude, je ne viens pas en voiture, mais j’ai loupé le bus… Il faut vraiment que j’arrête de partir à la dernière minute.",
                        "audioSrc": "/audio/EnfantRetardE9-1.mp3"
                    }
                ]
            },
            {
                "id": 97,
                "info": "La zone cliquable est : Une maman avec la trottinette de son fils qui peine à se rendre au collège car des voitures sont garées sur le trottoir pour déposer leurs enfants.",
                "personSrc": "/img/MamanEmbetee.png",
                "personName": "Maman avec la trottinette et sa fille",
                "required": false,
                "coords": {
                    "x": 2207,
                    "y": 509
                },
                "width": 128,
                "height": 300,
                "buttonText": "Fermer",
                "color": "rose_fonce",
                "content": [
                    {
                        "text": "Les automobilistes qui se garent sur le trottoir pour déposer leurs enfants ou les attendre après la sortie ne pensent pas à ceux qui viennent à pied…",
                        "audioSrc": "/audio/MamanEmbeteeE9-1.mp3"
                    }
                ]
            }, {
                "id": 98,
                "info": "La zone cliquable est : Un vieux monsieur",
                "personSrc": "/img/VieuxMonsieur.png",
                "personName": "Vieux monsieur",
                "required": false,
                "coords": {
                    "x": 200,
                    "y": 772
                },
                "width": 107,
                "height": 292,
                "buttonText": "Fermer",
                "color": "sapin",
                "content": [
                    {
                        "text": "Il y a vraiment beaucoup de circulation aujourd’hui ! À mon époque, on allait tous à l’école à pied ou en bus et c’était très bien !",
                        "audioSrc": "/audio/VieuxMonsieurE9-1.mp3"
                    }
                ]

            }, {
                "id": 99,
                "info": "La zone cliquable est : Un enfant qui fait signe au conducteur",
                "personSrc": "/img/EnfantSigneChauffeur.png",
                "personName": "Enfant qui fait signe au conducteur",
                "required": false,
                "coords": {
                    "x": 1928,
                    "y": 1360
                },
                "width": 120,
                "height": 265,
                "buttonText": "Fermer",
                "color": "sapin",
                "content": [
                    {
                        "text": "Mes parents se sont décidés à acheter une voiture électrique. C’est plus écologique, mais il faut qu’on fasse attention, car on ne l’entend même plus arriver…",
                        "audioSrc": "/audio/EnfantSigneChauffeurE9-1.mp3"
                    }
                ]
            },
            {
                "id": 100,
                "info": "La zone cliquable est : la porte du collège",
                "personSrc": "/img/Maitresse.png",
                "personName": "Professeure du collège",
                "required": false,
                "coords": {
                    "x": 2556,
                    "y": 34
                },
                "width": 200,
                "height": 583,
                "buttonText": "Clique ici pour passer au quiz.",
                "buttonTextCancel": "Non, je souhaite encore me balader aux abords du collège.",
                "goquiz": true,
                "color": "or",
                "content": [
                    {
                        "text": "Bravo, tu as pris le bus pour venir au collège ! Tu vas voir, ça fait du bien d’être autonome. On a l’impression d’être vraiment grand tout à coup. Et c’est un mode de transport bien plus écologique ! <br> Te sens-tu prêt à vérifier que tu as bien retenu les enseignements reçus tout au long de ton trajet en bus ? ",
                        "audioSrc": "/audio/MaitresseE9-1.mp3"
                    }
                ]
            }
        ]
    }
]

export default interactiveDataJson;